<template>
  <div>
    <canvas class="graph-chart" ref="chart" id="myChart"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
import { clone } from "lodash";

export default {
  name: "graph_chart",
  props: {
    graph_config: {}
  },
  data() {
    return {
      ctx: undefined,
      chart: undefined
    };
  },
  computed: {},
  methods: {
    createCharts(data) {
      this.ctx = this.$refs["chart"];
      this.chart = new Chart(this.ctx, {
        // The type of chart we want to create
        type: data.type,
        // The data for our dataset
        data: {
          labels: data.labels
            ? data.labels.map(item => {
                return item.label;
              })
            : [],
          datasets: data.datasets
        },
        // Configuration options go here
        options: {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            mode: "index",
            intersect: false,
            position: "nearest",
            xAlign: "center",
            yAlign: "center",
            titleFontSize: 10,
            bodyFontSize: 10,
            footerFontSize: 8,
            itemSort: (pre, cur) => {
              if (pre.yLabel >= cur.yLabel) {
                return -1;
              } else {
                return 1;
              }
            },
            callbacks: {
              label: (tooltipItem, data) => {
                let value = undefined;
                if (tooltipItem.yLabel || tooltipItem.yLabel === 0) {
                  value =
                    " " +
                    tooltipItem.yLabel +
                    "%" +
                    ` ${data.datasets[tooltipItem.datasetIndex].label}`;
                } else {
                  value =
                    " 暂无数据" +
                    ` ${data.datasets[tooltipItem.datasetIndex].label}`;
                }
                return value;
              }
            }
          },
          hover: {
            mode: "nearest",
            intersect: true
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                display: true,
                maxBarThickness: 30,
                scaleLabel: {
                  display: true
                },
                gridLines: {
                  color: "rgba(0, 0, 0, 0)", // 隐藏要y轴轴线
                  zeroLineColor: "#eeeeee",
                  lineWidth: 0.5
                },
                ticks: {}
              }
            ],
            yAxes: [
              {
                display: true,
                scaleLabel: {
                  // display: true
                },
                gridLines: {
                  color: "#eeeeee", // 隐藏要x轴轴线
                  zeroLineColor: "#eeeeee",
                  lineWidth: 0.5
                },
                ticks: {
                  // Include a percent sign in the ticks
                  callback: function(value, index, values) {
                    return value + "%";
                  },
                  beginAtZero: true
                }
              }
            ]
          }
        }
      });
      this.$emit("loadingStatus", false);
    }
  },
  watch: {
    graph_config: {
      handler: function(to, from) {
        if (this.chart) {
          this.chart.destroy();
        }
        this.createCharts(clone(to));
      },
      deep: true
    }
  },
  created() {
    // this.createCharts(this.graph_config);
  },
  mounted() {
    this.createCharts(this.graph_config);
  },
  destroyed() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style lang="scss" scoped>
.graph-chart {
  width: 90%;
  height: 100%;
}
</style>

